export function headerFunc() {
  // ハンバーガーメニュー実装
  $('.navToggle').on('click', function() {
    $('.navToggle').toggleClass('closeNav');
    $('.headerNav').toggleClass('openNav');
    $('body').toggleClass('menuOpen');
  });

  $('.headerNavList a').on('click', function() {
    $('.headerNav').removeClass('openNav');
    $('.navToggle').removeClass('closeNav');
  });
}

export function headerScrFunc() {
  console.log('スクロールで呼ばれます。');
}